import React from 'react'
import {
    _getKey,
    getFileType,
    getIconByFileType,
    getImageExt,
    IMAGE_EXTS
} from '../helpers/Util'
import { ReactComponent as IconFileClose } from '../../assets/icons/old/fileClose.svg'
import Tooltip from '@mui/material/Tooltip'
import Image from './Image'

export const SelectedFileViewComponent = ({
    file,
    showRemoveOption,
    index,
    remove
}) => {
    let ext = getImageExt(file.name)
    const fileType = getFileType(file.name)
    if (IMAGE_EXTS.includes(ext)) {
        return (
            <div className='item'>
                {showRemoveOption ? (
                    <div className='close' onClick={() => remove(index)}>
                        <IconFileClose />
                    </div>
                ) : (
                    <></>
                )}

                <a href={file.docUrl} target='_blank' rel='noreferrer'>
                    <Tooltip title={file.name} arrow placement={'top'}>
                        <Image
                            src={
                                showRemoveOption ? file.base64Str : file.docUrl
                            }
                            alt=''
                            isStatic={false}
                        />
                    </Tooltip>
                </a>
            </div>
        )
    }

    return (
        <>
            {showRemoveOption ? (
                <div className='close' onClick={() => remove(index)}>
                    <IconFileClose />
                </div>
            ) : (
                <></>
            )}
            <a href={file.docUrl} target='_blank' rel='noreferrer'>
                <Tooltip title={file.name} arrow placement={'top'}>
                    <span>
                        <Image src={getIconByFileType(fileType)} alt='' />
                    </span>
                </Tooltip>
            </a>
        </>
    )
}
